@if (buildActivity) {
    <div class="cb-margin-top flex-col flex cb-margin-left">
        <cb-checkbox
            name="shouldExcludeRequiredComplianceForDuplicates"
            label="Exclude required compliance for duplicate Activities in Build"
            [(ngModel)]="buildActivity.shouldExcludeRequiredComplianceForDuplicates"
        >
        </cb-checkbox>
        <body>
            <p>Select which type to link to this build activity or remove the type to change</p>
        </body>
        <mat-radio-group
            name="TypeState"
            class="layoutGap-28"
            [(ngModel)]="triStateSelector"
            [disabled]="isBuildActivityATradeType() || isBuildActivityASupplyType()"
        >
            <mat-radio-button [value]="null">None</mat-radio-button>
            <mat-radio-button [value]="true">Trade Type</mat-radio-button>
            @if (isSupplierTypesEnabled) {
                <mat-radio-button [value]="false">Supply Type</mat-radio-button>
            }
        </mat-radio-group>
        @if (isBuildActivityATradeType()) {
            <div>
                <cb-select-items-autocomplete-scroller
                    class="flex"
                    heading="Trade Types"
                    [displayFn]="displayFnTrade"
                    name="tradeType1"
                    [(ngModel)]="buildActivity.tradeTypesList"
                    (change)="tradeTypesChanged()"
                    [selectedItem]="selectedTradeType"
                >
                    <cb-trade-type-autocomplete-scroller
                        class="cb-margin-top flex flex-row"
                        label="Select Trade Type"
                        [disabled]="cannotAddTradeOrSupplyType"
                        name="tradeType"
                        [(ngModel)]="selectedTradeType"
                        [ignoreDirty]="true"
                    >
                    </cb-trade-type-autocomplete-scroller>
                </cb-select-items-autocomplete-scroller>
                <div class="cb-margin flex-col flex">
                    @if (availableDocTypes.$resolved) {
                        <mat-form-field>
                            <mat-label> Required Compliance </mat-label>
                            <mat-select
                                [(ngModel)]="buildActivity.requiredComplianceId"
                                name="requiredCompliance"
                            >
                                @for (
                                    availableDocType of availableDocTypes;
                                    track availableDocType
                                ) {
                                    <mat-option [value]="availableDocType.id">
                                        {{ availableDocType.label }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
            </div>
        }
        @if (isBuildActivityASupplyType()) {
            <div>
                <cb-select-items-autocomplete-scroller
                    class="flex"
                    heading="Supply Types"
                    [displayFn]="displayFnSupply"
                    name="supplyType1"
                    [(ngModel)]="buildActivity.supplyTypesList"
                    (change)="supplyTypesChanged()"
                    [selectedItem]="selectedSupplyType"
                >
                    <cb-supply-type-autocomplete-scroller
                        class="cb-margin-top flex flex-row"
                        label="Select Supply Type"
                        [disabled]="cannotAddTradeOrSupplyType"
                        name="supplyType"
                        [(ngModel)]="selectedSupplyType"
                        [ignoreDirty]="true"
                    >
                    </cb-supply-type-autocomplete-scroller>
                </cb-select-items-autocomplete-scroller>
                <div class="cb-margin flex-col flex">
                    @if (availableDocTypessupply.$resolved) {
                        <mat-form-field>
                            <mat-label> Required Compliance </mat-label>
                            <mat-select
                                [(ngModel)]="buildActivity.requiredComplianceId"
                                name="requiredCompliance"
                            >
                                @for (
                                    availableDocTypessupply of availableDocTypessupply;
                                    track availableDocTypessupply
                                ) {
                                    <mat-option [value]="availableDocTypessupply.id">
                                        {{ availableDocTypessupply.label }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
            </div>
        }
    </div>
}
